<script setup>
import { useI18n } from 'vue-i18n'
import TitleComponent from "@/components/TitleComponent/index.vue"
const { t } = useI18n();
import { useRouter } from 'vue-router'
const router = useRouter()
const goBack = () => {
    router.go(-1);
}
const isMobile=ref(false);//false代表pc
onMounted(() => { 
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      console.log('Is mobile device:', isMobile.value);
})
</script>
<template>
    <div class="container">
        <TitleComponent v-if="isMobile" :title="t('setup138')"></TitleComponent>

       
    <div class="packContent">
        <div class="title">
            {{ $t('setup138') }}
        </div>
        <div class="Headline">
            {{ $t('setup183') }}
        </div>
        <div class="Subtitle">{{ $t('setup184') }}</div>
        <div class="Subtitle">{{ $t('setup185') }}</div>
        <div class="Subtitle">{{ $t('setup186') }}</div>
        <div class="Subtitle" style="padding-bottom: 45px;">{{ $t('setup187') }}</div>
        <div class="content">
            <div class="Subtitle-title">
                {{ $t('setup188') }}
            </div>
            <p class="Subtitle-content">{{ $t('setup189') }}</p>
            <p class="Subtitle-content">{{ $t('setup190') }}</p>
            <p class="Subtitle-content">{{ $t('setup191') }}</p>
            <p class="Subtitle-content">{{ $t('setup192') }}</p>
            <p class="Subtitle-content">{{ $t('setup193') }}</p>
            <p class="Subtitle-content">{{ $t('setup194') }}</p>
            <p class="Subtitle-content">{{ $t('setup195') }}</p>
            <p class="Subtitle-content">{{ $t('setup196') }}<span>{{ $t('setup197') }}</span> </p>
            
        </div>
        <div class="content">
            <div class="Subtitle-title">
                {{ $t('setup198') }}
            </div>
            <p class="Subtitle-content">{{ $t('setup199') }}</p>
            <p class="Subtitle-content">{{ $t('setup200') }}</p>
            <p class="Subtitle-content">{{ $t('setup201') }}</p>
            <p class="Subtitle-content">{{ $t('setup202') }}</p>
            <p class="Subtitle-content">{{ $t('setup203') }}</p>
            <p class="Subtitle-content">{{ $t('setup204') }}</p>
            <p class="Subtitle-content">{{ $t('setup205') }}</p>
            <p class="Subtitle-content">{{ $t('setup206') }}</p>
            <p class="Subtitle-content">{{ $t('setup207') }}</p>
            <p class="Subtitle-content">{{ $t('setup208') }}</p>
            <p class="Subtitle-content">{{ $t('setup209') }}</p>
            <p class="Subtitle-content">{{ $t('setup210') }}</p>
            <p class="Subtitle-content">{{ $t('setup211') }}</p>
            <p class="Subtitle-content">{{ $t('setup212') }}</p>
            <p class="Subtitle-content">{{ $t('setup213') }}</p>
            <p class="Subtitle-content">{{ $t('setup214') }}</p>
        </div>
        <div class="content">
            <div class="Subtitle-title">
                {{ $t('setup215') }}
            </div>
            <p class="Subtitle-content">{{ $t('setup216') }}</p>
            <p class="Subtitle-content">{{ $t('setup217') }}</p>
        </div>
        <div class="content">
            <div class="Subtitle-title">
                {{ $t('setup218') }}
            </div>
            <p class="Subtitle-content">{{ $t('setup219') }}</p>
           
        </div>
        <div class="content">
            <div class="Subtitle-title">
                {{ $t('setup220') }}
            </div>
            <p class="Subtitle-content">{{ $t('setup221') }}</p>
        </div>
        <div class="content">
            <div class="Subtitle-title">
                {{ $t('setup222') }}
            </div>
            <p class="Subtitle-content">{{ $t('setup223') }}alin19991207@51shopy.com</p>
        </div>
    </div>
</div>
</template>
<style scoped lang='scss'>
.container{
    width: 100%;
}
.title {
    // padding-top: 40px;
    color: #282828;
    font-weight: 700;
    font-size: 25px;
    padding-bottom: 16px;
}

.Headline {
    padding: 8px 0px;
    font-size: 18px;
    line-height: 30px;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}

.Subtitle {
    font-size: 14px;
    line-height: 30px;
    // overflow: hidden;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}

.content {
    padding: 45px 0;

    .Subtitle-title {
        font-weight: 700;
        font-size: 14px;
        line-height: 30px;
        overflow: hidden;
        color: #131926;
        font-family: Montserrat, Arial, sans-serif;
    }

    .Subtitle-content {
        font-size: 14px;
        line-height: 30px;
        overflow: hidden;
        color: #131926;
        font-family: Montserrat, Arial, sans-serif;

        span {
            color: #fd560f;
        }
    }
}
@media (max-width: 768px) {
    .container{
        width: 100%;
    }
    .content{
        padding-top: 0px;
    }
    .packContent{
        padding: 55px 20px 100px 20px;
        .title{
            display: none;
        }
    }
    .Headline{
    padding: 8px 0px;
    font-size: 16px;
    line-height: 30px;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}
   
   
}
</style>